import { render, staticRenderFns } from "./DhmeAssemblyHallDashboardAutomatedTrestles.vue?vue&type=template&id=54642624&scoped=true"
import script from "./DhmeAssemblyHallDashboardAutomatedTrestles.vue?vue&type=script&lang=js"
export * from "./DhmeAssemblyHallDashboardAutomatedTrestles.vue?vue&type=script&lang=js"
import style0 from "./DhmeAssemblyHallDashboardAutomatedTrestles.vue?vue&type=style&index=0&id=54642624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54642624",
  null
  
)

export default component.exports